import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import Signin from "./Signin/Signin";
import Dashboard from "./Dashboard/Dashboard";
import Register from "./Register/Register";
import { useAuth } from "../../provider/Auth.provider";
import { findUserByUID } from "../../service/findUsers/findUserByUID";

const TeamLeader = () => {
  const { user, loading } = useAuth();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setIsRegistering(searchParams.get("action") === "register");
  }, [location.search]);

  useEffect(() => {
    const checkUserAccess = async () => {
      try {
        if (!user?.uid) {
          setIsSignedIn(false);
          return;
        }
        const userDetails = await findUserByUID(user.uid);
        if (userDetails?.userTypes === "team_leader") {
          setIsSignedIn(true);
          navigate("/teamleader/dashboard", { replace: true });
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while checking user access",
          placement: "topRight",
          duration: 3,
        });
        setIsSignedIn(false);
      }
    };

    checkUserAccess();
  }, [user, navigate]);

  if (loading) {
    return <p>Loading...</p>;
  }

  console.log(user);

  return (
    <>
      {!isSignedIn ? isRegistering ? <Register /> : <Signin /> : <Dashboard />}
    </>
  );
};

export default TeamLeader;
